export enum AnalysisStatus {
  Completed = "Completed",
  InProgress = "In progress",
  Archived = "Archived",
  Restore = "Restore",
}

export enum ProductsShortlistValidationStatus {
  Valid = "Valid",
  NoShortlisted = "NoShortlisted",
  HasUndecided = "HasUndecided",
  ShortlistLimitExceeded = "ShortlistLimitExceeded",
}
